import { Navigate, useNavigate } from 'react-router-dom';
import { OwcTypography } from '@one/react';
import ReleaseTabs from '../../components/Modal/ReleaseTabs';
import styles from './ManageReleasePage.module.css';
import { useUserRoles } from '../../hooks/useUserRoles';

export default function ManageReleasePage() {
  const navigate = useNavigate();
  const { allowManageRelease } = useUserRoles();

  const handleClose = () => {
    navigate(-1);
  };

  // The nav entry is hidden for these users, but the route is still reachable
  // by URL — send them back to the dashboard rather than rendering the page.
  if (!allowManageRelease) return <Navigate to="/dashboard" replace />;

  return (
    <div className={styles.container}>
      <OwcTypography variant="title4">
        Manage Release : Events / Resources / ComplexDataTypes
      </OwcTypography>
      <OwcTypography className={styles.subtitle}>
        Select unreleased Events, Resources and Complex Data Types to create a new release.
      </OwcTypography>

      <div className={styles.content}>
        <ReleaseTabs onClose={handleClose} />
      </div>
    </div>
  );
}
